export const PENDING_STATUS = 'PENDING';
export const ACTIVE_STATUS = 'ACTIVE';
export const CANCELLED_STATUS = 'CANCELLED';
export const UNPAID_STATUS = 'UNPAID';
export const TRIAL_PERIOD = 'TRIAL_PERIOD';
export const BLOCKED_STATUS = 'BLOCKED';

export type SubscriptionStatus =
  | typeof PENDING_STATUS
  | typeof ACTIVE_STATUS
  | typeof CANCELLED_STATUS
  | typeof UNPAID_STATUS
  | typeof TRIAL_PERIOD
  | typeof BLOCKED_STATUS;
